// src/components/admin/flows/canvas/CanvasConnection.js
import React from 'react';
import { NODE_WIDTH, NODE_HEIGHT } from './nodeRegistry';

const CanvasConnection = ({ connection, steps, isSelected, onSelect, isDark }) => {
    const fromStep = steps.find(s => s.id === connection.from_step_id);
    const toStep = steps.find(s => s.id === connection.to_step_id);

    if (!fromStep || !toStep) return null;

    // Calculate start point (from output port)
    let startX, startY;
    if (fromStep.type === 'condition' && connection.condition_branch) {
        const xOffset = connection.condition_branch === 'true' ? 0.3 : 0.7;
        startX = fromStep.position.x + NODE_WIDTH * xOffset;
        startY = fromStep.position.y + NODE_HEIGHT;
    } else {
        startX = fromStep.position.x + NODE_WIDTH / 2;
        startY = fromStep.position.y + NODE_HEIGHT;
    }

    // Calculate end point (to input port)
    const endX = toStep.position.x + NODE_WIDTH / 2;
    const endY = toStep.position.y;

    // Bezier control points
    const dy = Math.abs(endY - startY);
    const controlOffset = Math.max(50, dy * 0.4);

    const path = `M ${startX} ${startY} C ${startX} ${startY + controlOffset}, ${endX} ${endY - controlOffset}, ${endX} ${endY}`;

    const strokeColor = isSelected
        ? '#3b82f6'
        : connection.condition_branch === 'true'
        ? '#22c55e'
        : connection.condition_branch === 'false'
        ? '#ef4444'
        : isDark ? '#6b7280' : '#9ca3af';

    return (
        <g onClick={(e) => { e.stopPropagation(); onSelect(connection.id); }} style={{ pointerEvents: 'auto' }}>
            {/* Invisible wider path for easier clicking */}
            <path
                d={path}
                fill="none"
                stroke="transparent"
                strokeWidth={16}
                style={{ cursor: 'pointer' }}
            />
            {/* Visible path */}
            <path
                d={path}
                fill="none"
                stroke={strokeColor}
                strokeWidth={isSelected ? 2.5 : 2}
                strokeDasharray={isSelected ? 'none' : 'none'}
                style={{ cursor: 'pointer', transition: 'stroke 0.15s' }}
            />
            {/* Arrow head */}
            <polygon
                points={`${endX},${endY} ${endX - 5},${endY - 8} ${endX + 5},${endY - 8}`}
                fill={strokeColor}
                style={{ transition: 'fill 0.15s' }}
            />
            {/* Label */}
            {connection.label && (
                <text
                    x={(startX + endX) / 2}
                    y={(startY + endY) / 2 - 6}
                    textAnchor="middle"
                    className={`text-[10px] font-medium select-none pointer-events-none ${
                        isDark ? 'fill-gray-400' : 'fill-gray-500'
                    }`}
                >
                    {connection.label}
                </text>
            )}
        </g>
    );
};

export default CanvasConnection;
